/** @module                         Hooks */

import { useTranslation }           from "react-i18next";

/** @module                         Components */

import { NavLink }                  from "react-router-dom";

import ComponentLoader              from "../Loaders/ComponentLoader";


const 

/**
 * 
 * @param { Boolean } loading
 * 
 * @param { Object } data
 * 
 * @param { String } id
 * 
 * @returns pages lanugage tabs component
 * 
 */

Tabs = ( { loading, data, pageType } ) => { const { t } = useTranslation ();

    /** @return */

    return ( 
        
        loading ? <ComponentLoader size={ 1 } /> : 
        
        <div className="tabs">

            <NavLink 
                
                to={ `/app/pages/${ pageType }` } end
            
                className={ ( { isActive } ) => ( isActive ? 'active' : 'inactive' ) }>

                { t ( "all" ) }

            </NavLink>

            { data.__type.enumValues.map 
            
                ( ( tab, index ) => 
            
                    <NavLink 
                        
                        to={ `/app/pages/${ pageType }/${ tab.name }` }
                    
                        key={ index } 
                    
                        className={ ( { isActive } ) => ( isActive ? 'active' : 'inactive' ) }>

                        { tab.name.toUpperCase () }

                    </NavLink> 
            
                ) 
            
            }
    
        </div> 
    
    );

}

/** @export Tabs */
 
export default Tabs;